import React, { useMemo } from 'react'
import { FormikProps, useFormikContext } from 'formik'
import { BoxV4 } from '@labrav/react-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faListCheck } from '@fortawesome/pro-regular-svg-icons'
import { makeStyles } from 'tss-react/mui'
import { PaymentScheduleV2 } from '../PaymentScheduleV2/PaymentScheduleV2'
import { awsMaxScheduledInstallments } from '../../utils/constants'
import {
  RENEWAL_HEADING_ICON_STYLE,
  RENEWAL_INSTALLMENTS_SECTION_INFO,
  RenewalCountOption,
  RenewalPricingTermsOption,
  RenewalSectionInfoIcon,
  resolveSeedUpliftPercent,
  type RenewalPricingFormValues,
} from '../../utils/renewalPricingTerms'

const useStyles = makeStyles()(theme => ({
  info: {
    width: theme.spacing(2),
    height: theme.spacing(2),
    fontSize: theme.spacing(2),
    color: theme.palette.labraIcon.main,
  },
}))

export const PrivateOfferRenewalInstallments: React.FC = () => {
  const { classes } = useStyles()
  const formikProps =
    useFormikContext() as FormikProps<RenewalPricingFormValues>
  const { values } = formikProps

  const show =
    !!values.flexiblePaymentTerms &&
    values.renewalPricingTerms !== RenewalPricingTermsOption.NO_RENEWAL &&
    (values.renewalCountType === RenewalCountOption.DEFINITE ||
      values.renewalCountType === RenewalCountOption.INDEFINITE)

  const seedUpliftPercent = resolveSeedUpliftPercent(values)
  const upliftedTcv = useMemo(() => {
    const base = Number(values.tcv) || 0
    return Math.round(base * (1 + seedUpliftPercent / 100) * 100) / 100
  }, [seedUpliftPercent, values.tcv])

  if (!show) return null

  return (
    <div data-testid="renewal-installments-section">
      <BoxV4
        heading="Renewal installments"
        headingIcon={
          <FontAwesomeIcon
            icon={faListCheck}
            style={RENEWAL_HEADING_ICON_STYLE}
          />
        }
        secondaryActions={
          <RenewalSectionInfoIcon
            description={RENEWAL_INSTALLMENTS_SECTION_INFO}
            testId="renewal-installments-section-info"
            className={classes.info}
          />
        }
      >
        <PaymentScheduleV2
          {...({
            formik: formikProps as unknown as FormikProps<
              Record<string, unknown>
            >,
            addButtonName: 'Add more installments',
            buttonCounterName: 'installments',
            shouldShowTotal: true,
            installmentsLimit: awsMaxScheduledInstallments,
            sectionHeading: '',
            sectionDescription: '',
            tcv: upliftedTcv,
            mode: 'renewal',
            installmentsField: 'renewalInstallments',
            scheduleTypeField: 'renewalFlexiblePaymentType',
            dayOfMonthField: 'renewalDayOfMonth',
            hideTcvInput: true,
            hideGenerateButton: true,
            priceUpliftPercent: seedUpliftPercent,
          } as unknown as React.ComponentProps<typeof PaymentScheduleV2>)}
        />
      </BoxV4>
    </div>
  )
}
